import { render } from "./HomeView.vue?vue&type=template&id=ca206592&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=ca206592&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca206592"

export default script